module.exports = __webpack_public_path__ + "img/evo.e017e15b.png";